const configurations = {
    port: 9000,
    goliathDataServiceUrl: 'http://localhost:8100/',
    armidilloMlServiceUrl: 'http://localhost:3000/'
};

export default configurations;
